import * as AT from "src/core/orders/store/orders.constants";
import { IProduct } from "src/core/products/api/products.api";
import { IProductSubstitution } from "src/modules/substitutions/api/substitutions.api";

import { ICurrentOrder } from "../api/orders.api";

export type OrderActions = ISetCurrentOrder | ISetCurrentOrderMode | ISetOrdersWithErrors | IPurgeOrders | IUpdateCustomerReference | IUpdateOrderLine;

interface IUpdateOrderLine {
  type: AT.UPDATE_ORDER_LINE;
  product: IProduct;
  newQuantity: number;
  substitution?: IProductSubstitution;
}

export const updateOrderLine = (product: IProduct, newQuentity: number, substitution?: IProductSubstitution): IUpdateOrderLine => {
  return {
    type: AT.UPDATE_ORDER_LINE,
    product,
    newQuantity: newQuentity,
    substitution
  };
};

interface ISetCurrentOrder {
  type: AT.SET_CURRENT_ORDER;
  order: ICurrentOrder | null;
}

export const setCurrentOrder = (order: ICurrentOrder | null): ISetCurrentOrder => {
  return {
    type: AT.SET_CURRENT_ORDER,
    order
  };
};

interface ISetCurrentOrderMode {
  type: AT.SET_CURRENT_ORDER_MODE;
  mode: ICurrentOrder["mode"] | null;
}

export const setCurrentOrderMode = (mode: ICurrentOrder["mode"] | null): ISetCurrentOrderMode => {
  return {
    type: AT.SET_CURRENT_ORDER_MODE,
    mode
  };
};

interface ISetOrdersWithErrors {
  type: AT.SET_ORDERS_WITH_ERRORS;
  allOrdersWithErrors: number;
}

export const setOrdersWithErrors = (allOrdersWithErrors: number): ISetOrdersWithErrors => {
  return {
    type: AT.SET_ORDERS_WITH_ERRORS,
    allOrdersWithErrors
  };
};

interface IUpdateCustomerReference {
  type: AT.UPDATE_CUSTOMER_REFERENCE;
  reference: string;
}

export const updateCustomerReference = (reference: string): IUpdateCustomerReference => {
  return {
    type: AT.UPDATE_CUSTOMER_REFERENCE,
    reference
  };
};

interface IPurgeOrders {
  type: AT.PURGE_ORDERS;
}

export const purgeOrders = (): IPurgeOrders => {
  return { type: AT.PURGE_ORDERS };
};
